import { render, staticRenderFns } from "./SectionSocialImpact.vue?vue&type=template&id=0afc335a&scoped=true"
import script from "./SectionSocialImpact.vue?vue&type=script&lang=js"
export * from "./SectionSocialImpact.vue?vue&type=script&lang=js"
import style0 from "./SectionSocialImpact.vue?vue&type=style&index=0&id=0afc335a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afc335a",
  null
  
)

export default component.exports